export default "__VITE_ASSET__275142c6__"